<!-- eslint-disable -->

<template>
	<div>
		<PaxelLoader :loading="loadingOverdueCalculation" style="
			position: absolute;
			top: 50%;
			left: 50%;
			transform: translate3d(-50%, -50%, 0);">
		</PaxelLoader>
		<div class="d-flex flex-column mb-5 bg-white rounded-lg px-4" v-if="!loadingOverdueCalculation">

			<InfoList :title="language == 'en' ? 'Rent Info' : 'Info Sewa'" :data="rentInfo" cta="orderstatus_overdue_rentinfo_copy_order_number" />

			<div class="divider my-4"></div>

			<div style="background-color: #EBEAF3;" class="rounded-lg p-4" v-if="!loadingOverdueCalculation"> 
				<div
					v-for="(item, index) in paymentInfo || []"
					:key="item.label + index"
					class=""
				>
					<div class="d-flex flex-column"> 
						<div class="d-flex justify-content-between">
							<div class="text-gotham align-self-center text-14" :style="item.labelStyle">
								{{ item.label }}
							</div>
							<div class="align-self-center text-gotham-bold text-14" :style="item.valueStyle">
								{{ item.isDate ? epochToDateTimeLocalFormat(item.value) || "-" : item.value }}
							</div>
						</div>
						<span
							v-if="item.info"
							class="text-gotham-bold text-12 align-self-end mt-2"
							style="color:#5F51A1;"
							>{{ item.info }}</span
						>
					</div>
					<hr>
				</div>
				<div class="py-4 px-3 rounded-lg" style="background-color: #FFFAEE;border:1px solid #FFE9B9"> 
					<div class="text-12 text-gotham-bold"> *{{ language == "en" ? "Final amount shown at payment page" : "Biaya final akan ditampilkan saat memilih pembayaran" }}</div>
				</div>
			</div>

			<div class="divider my-4"></div>

			<Collapsible
				id="history"
				cta="orderstatus_overdue_history_toggle"
				:title="language == 'en' ? 'Status History' : 'Riwayat Status'"
				:open="toogleHistory"
				@onClick="toogleHistory = !toogleHistory"
			>
				<History :data="logs" />
			</Collapsible>

			<div class="divider my-4"></div>

			<Collapsible
				id="info"
				cta="orderstatus_overdue_lokasi_toggle"
				:title="language == 'en' ? 'PaxelBox Location Info' : 'Info Lokasi PaxelBox'"
				:open="toogleInfo"
				@onClick="toogleInfo = !toogleInfo"
			>
				<div>
					<div class="py-2 text-gotham-bold" style="font-size: 16px;">
						{{ addressMain || "-" }}
					</div>
					<div class="text-gotham text-left" style="font-size: 12px;line-height: 16px;">
						{{ addressDetail || "-" }}
					</div>
					<div class="py-2 "  v-if="lat && long">
						<span
							data-cta="orderstatus_overdue_lokasi_lihat_peta"
							@click="openMapLink"
							class="text-purple text-gotham-bold text-left"
							style="font-size: 12px;line-height: 16px;color: #5e51a1;"
							>{{ language == "en" ? "See map" : "Lihat peta" }} >
						</span>
					</div>
					<div class="py-2 text-gotham text-left" style="font-size: 12px;line-height: 16px;">
						{{ addressAdditionalDetail || "-" }}
					</div>
					<div
						class="py-2 text-gotham text-left"
						style="font-size: 12px;line-height: 16px;white-space:pre-wrap"
					>
						<div>{{ language == "en" ? "Operational Hours" : "Jam Operasional" }} :</div>
						<div class="mt-2">{{ operationalHour || "-" }}</div>
					</div>
					<div class="row px-3">
						<div class="" style="height: 120px;width: 50%;">
							<img
								v-if="locker_photo"
								:src="locker_photo"
								class="image-fit"
								data-cta="orderstatus_overdue_lokasi_foto_locker"
								@click="showPhoto(locker_photo)"
								@error="imageUrlNoContent"
								alt="Locker"
							/>
						</div>
					</div>
				</div>
			</Collapsible>

			<div class="divider my-4"></div>

			<div class="text-center mb-3 mx-6">
				<button
					class="button rounded-lg py-3 text-gotham-bold"
					style="width: 90%;background-color: white;border: 1px solid #5e51a1;color:#5e51a1;position:relative"
					data-cta="orderstatus_overdue_hera"
					@click="buttonContactSupport()"
				>
					{{ language == "en" ? "Need help? Contact HERA" : "Butuh bantuan? Hubungi HERA" }}
					<img src="@/assets/images/hera.svg" alt="hera" class="icon-hera-button">
				</button>
			</div>
			<div 
				class="text-center"
				:style="{
					background: 'white',
					position: 'sticky',
					bottom: '0',
					margin: '0 -1.5rem',
					padding: '0 1.5rem',
					marginBottom: '-1.5rem',
					paddingBottom: '1.5rem',
				}"
			>	
				<button
					class="button rounded-lg py-3 text-gotham-bold shadow-lg"
					style="width: 100%;background-color:#5F51A1;color:white;border:1px solid #5F51A1;"
					:disabled="payProcessing"
					data-cta="orderstatus_overdue_bayar"
					@click="payOverdue()"
				>
					<loadingCircle
						class="flex-center w-full"
						:show-text="false"
						v-if="payProcessing"
					/>
					<span v-else class="text-gotham-bold text-white text-16" style="cursor: pointer">
						{{ language == "en" ? "Pay" : "Pilih Pembayaran" }}
					</span>
				</button>
			</div>
		</div>
	</div>
</template>
<script>
/* eslint-disable */
import Header from "./components/Header.vue";
import InfoList from "./components/InfoList.vue";
import Collapsible from "./components/Collapsible.vue";
import History from "./components/History.vue";
import Qrcode from "./components/Qrcode.vue";
import i18n from '@/plugins/i18n';
import LocalStorage from '@/services/localstorage';
import PaxelLoader from '@/components/PaxelLoader.vue';
import loadingCircle from '@/components/loadingCircle.vue';

export default {
	components: { Header, InfoList, Collapsible, History,Qrcode,PaxelLoader,loadingCircle },
	props: {
		status: {
			type: String,
			default: "in-store"
		},
		order: {
			type: Object,
			default() {
				return {};
			}
		},
		boxLocationDetail: {
			type: Object,
			default() {
				return {};
			}
		}
	},
	data() {
		return {
			loadingIcon: true,
			pakpoboxAPIUrl: process.env.VUE_APP_PAKPOBOX_API,
			heraUrl: process.env.VUE_APP_HERA_LINK,
			//
			addressMain: "",
			addressDetail: "",
			addressAdditionalDetail: "",
			mapUrl: '',
      operationalHour: '',
      lat: "",
			long: "",
			locker_photo: "",
			operationalHour: "",
			doorNumber: "-",
			rentDate: "",
			deadlineDate: "",
			overdueNewDate: "",
			orderNumber: "",
			size: "",
			paymentMethod: "",
			payOfAmount: "",
			rentUnit: "",
			paymentDetail: {},
			adminFee: {},
			donation: [],
			totalDonation: 0,
			overduePriceRentType: 0,
			rentTotalHour: 0,
			totalOverdue: 0,
			logs: [],
			toogleHistory: true,
			toogleInfo: true,
			showModal: false,
			isBase64: false,
			loadingOverdueCalculation: false,
			payProcessing: false,
		};
	},
	computed: {
		rentInfo() {
			return [
				{
					label: this.language == "en" ? "Rent Start" : "Sewa Dimulai",
					key:"title",
					value: this.rentDate,
					isDate: true
				},
				{
					label: this.language == "en" ? "Rent Ends" : "Batas Akhir Sewa",
					key:"deadlineDate",
					value: this.deadlineDate,
					isDate: true,
				},
				{
					label: this.language == "en" ? "Extended Until" : "Diperpanjang Sampai",
					key:"overdueNewDate",
					value: this.overdueNewDate,
					isDate: true,
					addBreak: true,
				},
				{
					label: this.language == "en" ? "Order Number" : "Nomor Order",
					key:"orderNumber",
					value: this.orderNumber
				},
				{
					label: this.language == "en" ? "PaxelBox Size" : "Ukuran PaxelBox",
					key:"boxSize",
					value: this.size
				}
			];
		},
		paymentInfo() {
			const arr = [
				{
					label: this.language == "en" ? "Rent Extension" : "Perpanjang Sewa",
					value: this.language == 'en' ? `${this.rentTotalHour} ${this.rentUnit}`: `${this.rentTotalHour} ${this.rentUnit}`,
					addBreak: true
				},
				{
					label: this.language == "en" ? `Rent Fee per ${this.rentUnit}` : `Biaya per ${this.rentUnit}`,
					value: this.formatRupiah(this.overduePriceRentType),
					addBreak: true
				},
				{
					label: this.language == "en" ? "Total Cost" : "Total Biaya",
					value: this.formatRupiah(this.totalOverdue),
					labelStyle: "font-weight:bold;font-size:14px",
					valueStyle: "font-weight:bold;font-size:16px",
					addBreak: true
				},
			];

			return arr;
		},
	},
	async mounted() {
		this.getOverdueCalculationRentals();
		this.doorNumber = this.order?.mouth.number;
		this.rentDate = this.order?.createTime;
		this.deadlineDate = this.order?.overdueTime;
		this.orderNumber = this.order?.expressNumber;
		this.addressMain = this.boxLocationDetail?.locker_location || "-";
		this.addressDetail = this.boxLocationDetail?.location_address || "-";
		this.addressAdditionalDetail = this.boxLocationDetail?.location_description || "-";
		this.lat = this.boxLocationDetail?.latitude
		this.long = this.boxLocationDetail?.longitude
		this.mapUrl = this.boxLocationDetail?.maps_link
		this.locker_photo = this.boxLocationDetail?.locker_photo
		this.operationalHour = this?.boxLocationDetail?.operational_hour;
		this.size = this.sizeDoorLabel(this.order?.mouth?.mouthType?.name)
		this.paymentMethod = this.order.paymentMethod;
		this.payOfAmount = this.order.payOfAmount;
		this.paymentDetail = this.order.payment_detail;
		this.logs = this.order.logs;
		let settings = this.$store.getters.getSettings;
		if(!settings){
			await this.$store.dispatch("getSettings")
		}
	},
	methods: {
		openMapLink() {
			this.buttonSyncOpenGmapLocation(this.lat, this.long, this.mapUrl)
		},
		contactHera(url) {
			window.location.href = url;
		},
		calculateRentHour(timestamp){
			var difference = Date.now() - timestamp;
			var hours = Math.floor(difference/1000/60/60);
			var dif = hours + 1;
			return dif
		},
		payOverdue(){
			let snap_bi_features = this.getSettingValue("enabled_userapp_feature","snap_bi_paxelbox")
			this.payProcessing = true;
			if(snap_bi_features?.value == 'enabled'){
				this.payViaSnapBI();
			}else{
				this.payNonSnapBI();
			}
		},
		payViaSnapBI(){
			const paramOrderId = this.$route.query.orderid;
			let url = window.location.origin+"/order-status?orderid="+paramOrderId
			let token = this.$route.query.token?this.$route.query.token:LocalStorage.getUserToken()
			if(token){
				url = url+"&token="+token
			}
			/// overdue 
			let userdata = JSON.parse(LocalStorage.getUserData())
			let payload = {
				"additionalInfo": {
					"customerDetails": {
						"email": userdata.email,
						"firstName": userdata.first_name,
						"lastName": userdata.last_name,
						"memberCode": userdata.member_code,
						"phone": userdata.phone
					},
					"items": [
						{
							"brand": "Size "+this.order.mouth.mouthType.name+", "+this.order.mouth.number,
							"category": "UA Paxelbox ",
							"id": this.order.mouth.id,
							"name": this.order.mouth.box.name,
							"price": {
								"currency": "IDR",
								"value": (this.overduePriceRentType * this.rentTotalHour).toString()
							},
							"quantity": "1"
						}
					],
					"language": userdata.language,
					"payOptionDetails": []
				},
				"isOverdue": true,
				"overdueDuration": this.rentTotalHour+" "+this.rentUnit,
				"partnerReferenceNo": this.order.expressNumber,
				"urlParam": {
					"isDeeplink": "N",
					"type": "PAY_RETURN",
					"url": url
				}
			}
			this.$store.dispatch('payOverdue',payload).then((data) => {
				window.location.href = data.data.checkoutUrl
				
			}).catch((error) => {
				this.payProcessing = false;
				const message = error.response.data.message || i18n.t('something_wrong');
				this.$swal({
					icon: 'error',
					title: 'Oops...',
					text: message,
				});
			});
		},
		payNonSnapBI(){
			const paramOrderId = this.$route.query.orderid;
			let url = window.location.origin+"/order-status?orderid="+paramOrderId+"&overdue=true"
			let token = this.$route.query.token?this.$route.query.token:LocalStorage.getUserToken()
			if(token){
				url = url+"&token="+token
			}
			let userdata = JSON.parse(LocalStorage.getUserData())
			this.$store.dispatch('getTokenPayment').then((responseToken) => {
				const accessToken = responseToken.data.access_token;
				const dataCreatePayment = {
					token: accessToken,
					formdata: {
						"order_info" : {
							"name" :userdata.first_name,
							"box_name" : this.order.mouth.box.name,
							"phone_number" :userdata.phone,
							"cancel_url" : `${url}&payment_status=CANCELLED`,
							"payment_type" : "extention",
							"localization" : "indonesia",
							"box_id" :  this.order.mouth.id,
							"door_number" : this.order?.mouth.number,
							"order_id" : this.order?.expressNumber,
							"price" : this.overduePriceRentType * this.rentTotalHour,
							"size" : this.order?.mouth?.mouthType?.name,
							"loker_order_type" : "rental",
							"success_url" : `${url}&payment_status=SUCCESS`,
							"duration" : this.rentTotalHour,
							"currency" : "Rp",
							"client" : "userapp_locker",
							"failed_url" : `${url}&payment_status=FAILED`
						},
					},
				};
				// call api create payment
				this.$store.dispatch('payOverdueRental', dataCreatePayment).then((responseCreate) => {
					window.location.href = responseCreate.payment_url;
				}).catch((error) => {
					this.payProcessing = false;
					const message = error.response.data.message || i18n.t('something_wrong');
					this.$swal({
						icon: 'error',
						title: 'Oops...',
						text: message,
					});
				});
			}).catch((error) => {
				this.payProcessing = false;
				const message = error.response.data.message || i18n.t('something_wrong');
				this.$swal({
					icon: 'error',
					title: 'Oops...',
					text: message,
				});
			});
		},
		getOverdueCalculationRentals(){
			const paramOrderId = this.$route.query.orderid;
			if(paramOrderId != undefined){
				this.loadingOverdueCalculation = true;
				this.$store.dispatch("getOverdueCalculationRentals", paramOrderId)
				.then((response) => {
					let overdue = response.data
					this.overdueNewDate = overdue.next_overdue_time
					this.rentTotalHour =  overdue.increase_duration
					this.overduePriceRentType = overdue.overdue_fee_per_unit
					this.totalOverdue = overdue.total_overdue_fee
					this.loadingOverdueCalculation = false;
					if(this.language == 'en'){
						this.rentUnit = overdue.rent_unit.toLowerCase()
					}else{
						this.rentUnit = overdue.rent_unit_bahasa.toLowerCase()
					}
				})
				.catch((error) => {
					this.loadingOverdueCalculation = false;
					const message = error.response.data.message || i18n.t('something_wrong');
					this.$swal({
						icon: 'error',
						title: 'Oops...',
						text: message,
					});
				});
			}else{
				console.log("not found");
			}
		}
	}
};
</script>
<style>
.door-number {
	font-size: 48px;
	color: #ff434f;
}
.divider {
	height: 1rem;
	background-color: #f9f9fb;
	margin-right: -1.5rem;
	margin-left: -1.5rem;
}
.text-16 {
	font-size: 16px;
}
</style>
